import { instanceAuth } from "api/apiConfig"

// List of all returning students (used by the table)
export const returningStudentsFetchAPI = async data => {
  try {
    // console.log("Fetch all returning students params in api", data)
    const response = await instanceAuth.get(
      "ReturningStudentsManagement/AllReturningData",
      {
        params: {
          ...data,
        },
      },
    )
    return response
  } catch (error) {
    console.log("error fetching returning students data...", error)
    throw error
  }
}

// Single returning student application details (used by the details/form page)
export const returningStudentDetailAPI = async id => {
  try {
    // console.log("Fetch returning student detail params in api", id)
    const response = await instanceAuth.get(
      "ReturningStudentsManagement/ReturningData",
      {
        params: {
          studentId: id,
        },
      },
    )
    return response
  } catch (error) {
    console.log("error fetching returning student detail...", error)
    throw error
  }
}
